export default "__VITE_ASSET__DjfCP0zK__"